
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hyiip", function(module, exports) {

$parcel$export(module.exports, "usePreloadClassificationEditorQueries", () => $edfbd3e7078701de$export$def23bb21563a15);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $9NZgb = parcelRequire("9NZgb");

var $dXFcv = parcelRequire("dXFcv");
const $edfbd3e7078701de$export$def23bb21563a15 = ({ spaceKey: spaceKey })=>{
    return (0, $gwFzn.useCallback)(()=>{
        if (!spaceKey || !(0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')) return;
        (0, $9NZgb.preloadDefaultAndSpaceClassificationLevels)(spaceKey);
        (0, $dXFcv.preloadOrgDefaultClassificationLevelIdQuery)();
    }, [
        spaceKey
    ]);
};

});
parcelRegister("dXFcv", function(module, exports) {

$parcel$export(module.exports, "preloadOrgDefaultClassificationLevelIdQuery", () => $3ea498ce7a9c29e9$export$b4af737490a54c0c);

var $d2LG0 = parcelRequire("d2LG0");

var $dYU3e = parcelRequire("dYU3e");
function $3ea498ce7a9c29e9$export$b4af737490a54c0c() {
    return (0, $dYU3e.query)({
        // Note: we need to use the same name to ensure the preload caching behavior works correctly
        // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
        query: (0, $d2LG0.default)`query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery{orgDefaultClassificationLevelId}`
    });
}

});



//# sourceMappingURL=ClassificationReadViewPopup.39a34326.js.map
